import * as React from "react";
import { Sanitize } from "components/common";
import useNotificationMessage from "components/notifications/hooks/useNotificationMessage";
import { Collapsible } from "common/components";
import { DataWell } from "security-app/components/common";
import { Row } from "security-app/components/common/FormBaseStyles";
import SeverityBadge from "./SeverityBadge";
function AlertDetails({ notification }) {
  const message = useNotificationMessage(notification);
  return /* @__PURE__ */ React.createElement(
    Collapsible,
    {
      title: /* @__PURE__ */ React.createElement(Row, { $align: "center" }, /* @__PURE__ */ React.createElement(SeverityBadge, { severity: notification.severity }), /* @__PURE__ */ React.createElement("span", null, message == null ? void 0 : message.title))
    },
    /* @__PURE__ */ React.createElement(DataWell, null, /* @__PURE__ */ React.createElement(Sanitize, { html: message == null ? void 0 : message.description }))
  );
}
export default AlertDetails;
